import { render } from "./Address.vue?vue&type=template&id=1423c93a&scoped=true"
import script from "./Address.vue?vue&type=script&lang=js"
export * from "./Address.vue?vue&type=script&lang=js"

import "./Address.vue?vue&type=style&index=0&id=1423c93a&lang=scss&scoped=true"

import exportComponent from "/var/www/miniapp-sigur-admin-panel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1423c93a"],['__file',"src/assets/js/pages/AddGate/Address.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1423c93a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1423c93a', __exports__)) {
    api.reload('1423c93a', __exports__)
  }
  
  module.hot.accept("./Address.vue?vue&type=template&id=1423c93a&scoped=true", () => {
    api.rerender('1423c93a', render)
  })

}


export default __exports__